export { default as AppStore } from './AppStore';
export { default as Arrow } from './Arrow';
export { default as ArrowDown } from './ArrowDown';
export { default as ArrowRight } from './ArrowRight';
export { default as ArrowRighyWhite } from './ArrowRighyWhite';
export { default as AvailablePhone } from './AvailablePhone';
export { default as Calling } from './Calling';
export { default as Cart } from './Cart';
export { default as Chat } from './Chat';
export { default as ChatIcon } from './ChatIcon';
export { default as ChatSend } from './ChatSend';
export { default as ChatUser } from './ChatUser';
export { default as CircleCheck } from './CircleCheck';
export { default as Clipboard } from './Clipboard';
export { default as Coverage } from './Coverage';
export { default as Currency } from './Currency';
export { default as CurrencyBig } from './CurrencyBig';
export { default as CurrencySmall } from './CurrencySmall';
export { default as DangerCircle } from './DangerCircle';
export { default as Day } from './Day';
export { default as EyePassword } from './EyePassword';
export { default as EyePasswordHide } from './EyePasswordHide';
export { default as FieldChecked } from './FieldChecked';
export { default as FileIcon } from './FileIcon';
export { default as FillUser } from './FillUser';
export { default as Gps } from './Gps';
export { default as HeaderCall } from './HeaderCall';
export { default as InfoCircle } from './InfoCircle';
export { default as InfoQuestion } from './InfoQuestion';
export { default as Linkedin } from './Linkedin';
export { default as List } from './List';
export { default as Lock } from './Lock';
export { default as Logo } from './Logo';
export { default as LogoGrey } from './LogoGrey';
export { default as LogoWhite } from './LogoWhite';
export { default as Menu } from './Menu';
export { default as Night } from './Night';
export { default as NotAvailablePhone } from './NotAvailablePhone';
export { default as NotFoundPageIcon } from './NotFoundPageIcon';
export { default as People } from './People';
export { default as Photo } from './Photo';
export { default as Play } from './Play';
export { default as PlayEmpty } from './PlayEmpty';
export { default as RedLogo } from './RedLogo';
export { default as Roaming } from './Roaming';
export { default as Search } from './Search';
export { default as Services } from './Services';
export { default as SliderDotIndicator } from './SliderDotIndicator';
export { default as SmallArrow } from './SmallArrow';
export { default as Stability } from './Stability';
export { default as Star } from './Star';
export { default as StarFill } from './StarFill';
export { default as StarRed } from './StarRed';
export { default as SuccessCircle } from './SuccessCircle';
export { default as SuccessIcon } from './SuccessIcon';
export { default as SuccessTick } from './SuccessTick';
export { default as Tick } from './Tick';
export { default as Telefon } from './Telefon';
export { default as TopArrow } from './TopArrow';
export { default as Twitter } from './Twitter';
export { default as UsersCircule } from './UsersCircule';
export { default as Warning } from './Warning';
export { default as YouTube } from './YouTube';
export { default as ArrRight } from './ArrRight';
export { default as ArrowVector } from './ArrowVector';
export { default as BakcellPageBanner } from './BakcellPageBanner';
export { default as BannerBottom } from './BannerBottom';
export { default as Basket } from './Basket';
export { default as BranderLogo } from './BranderLogo';
export { default as Bundle } from './Bundle';
export { default as Calendar } from './Calendar';
export { default as CallCalling } from './CallCalling';
export { default as Call } from './Call';
export { default as CallRoaming } from './CallRoaming';
export { default as Calls } from './Calls';
export { default as Check } from './Check';
export { default as CloseCircle } from './CloseCircle';
export { default as CloseMobile } from './CloseMobile';
export { default as CloseSquare } from './CloseSquare';
export { default as BakcellLogoNew } from './BakcellLogoNew';
export { default as Close } from './Close';
export { default as Cup } from './Cup';
export { default as CurrencyNotFill } from './CurrencyNotFill';
export { default as Document } from './Document';
export { default as Email } from './Email';
export { default as Facebook } from './Facebook';
export { default as FaqArrow } from './FaqArrow';
export { default as Filter } from './Filter';
export { default as Flash } from './Flash';
export { default as Global } from './Global';
export { default as GooglePlay } from './GooglePlay';
export { default as Huawei } from './Huawei';
export { default as Import } from './Import';
export { default as InfoCircleRed } from './InfoCircleRed';
export { default as Instagram } from './Instagram';
export { default as Location } from './Location';
export { default as Mail } from './Mail';
export { default as Moon } from './Moon';
export { default as Net } from './Net';
export { default as Note } from './Note';
export { default as OutlineLocation } from './OutlineLocation';
export { default as Pdf } from './Pdf';
export { default as QrBannerLogo } from './QrBannerLogo';
export { default as Ranking } from './Ranking';
export { default as Refresh } from './Refresh';
export { default as ScrollUp } from './ScrollUp';
export { default as SearchMobile } from './SearchMobile';
export { default as ServiceLogoBg } from './ServiceLogoBg';
export { default as Sms } from './Sms';
export { default as StarLogoBg } from './StarLogoBg';
export { default as Sun } from './Sun';
export { default as Support } from './Support';
export { default as TariffBanner } from './TariffBanner';
export { default as TariffBannerDesktop } from './TariffBannerDesktop';
export { default as TaskSquare } from './TaskSquare';
export { default as TickCircle } from './TickCircle';
export { default as Tooltip } from './Tooltip';
export { default as TopUpBalance } from './TopUpBalance';
export { default as TwoArrow } from './TwoArrow';
export { default as User } from './User';
export { default as WorldRoaming } from './WorldRoaming';
export { default as ArrowLeft } from './ArrowLeft';
export { default as LogOut } from './LogOut';
export { default as Home } from './Home';
export { default as Tariffs } from './Tariffs';
export { default as Packages } from './Packages';
export { default as DonutChart } from './DonutChart';
export { default as LinearChart } from './LinearChart';
export { default as SvgSupport } from './Support';
export { default as PlusPrimary } from './PlusPrimary';
export { default as LogoBkc } from './LogoBkc';
export { default as Attention } from './Attention';
export { default as RedIcon } from './RedIcon';
export { default as SimIcon } from './SimIcon';
export { default as HomeTablet } from './HomeTablet';
export { default as TariffsTablet } from './TariffsTablet';
export { default as PackagesTablet } from './PackagesTablet';
export { default as CurrencyInCircle } from './CurrencyInCircle';
export { default as BrandArrow } from './BrandArrow';
export { default as ArrowLeftNew } from './ArrowLeftNew';
export { default as ArrowRightNew } from './ArrowRightNew';
export { default as BakcellFooterLogo } from './BakcellFooterLogo';
export { default as StarLabel } from './StarLabel';
export { default as BrandLogout } from './BrandLogout';
export { default as Explore } from './Explore';
export { default as RedCircleCheck } from './RedCircleCheck';
export { default as TariffFiber } from './TariffFiber';
export { default as Address } from './Address';
export { default as CheckMark } from './CheckMark';
export { default as BranchIcon } from './BranchIcon';
export { default as AddressIcon } from './AddressIcon';
export { default as SelectBranch } from './SelectBranch';
export { default as Guarantee } from './Guarantee';
export { default as ProductFilterSVG } from './ProductFilter';
export { default as TrashIcon } from './TrashIcon';
export { default as Pen } from './Pen';
export { default as StatementIcon } from './StatementIcon';
export { default as ChevronRightArrow } from './ChevronRightArrow';
export { default as CalendarNumberSale } from './CalendarNumberSale';
export { default as Clock } from './Clock';
export { default as ZoomPlusIcon } from './ZoomPlusIcon';
export { default as ZoomMinusIcon } from './ZoomMinusIcon';
export { default as SvgEsim } from './Esim';
export { default as SvgDualSimCard } from './DualSimCard';
export { default as SvgSimCard } from './SimCard';
export { default as Delete } from './Delete';
